// @flow
import type {
  User,
} from 'fc-model-users/types'

// Selectors
import authenticatedUser$ from './authenticatedUser'

// Utils
import {
  PROP_FIRST,
  PROP_LAST,
  PROP_USERNAME,
} from 'fc-model-users'

// Exports
export default (state: {}): string => {
  const user: ?User = authenticatedUser$(state)

  if (user) {
    const first = user[PROP_FIRST]
    const last = user[PROP_LAST]
    const full = (first && last) ? first + ' ' + last : (first || last)
    const username = user[PROP_USERNAME]

    if (full && username) {
      return `${full} (${username})`
    } else if (full || username) {
      return `${full || username})`
    }
  }

  return ''
}
